import { createContext } from 'react';
// eslint-disable-next-line max-len
import { EndorsementServiceFeaturesGetAvailableNationalitiesAvailableNationalitiesDto as NationalitiesDto } from '@sdir/httpclient/lib/clients/aps/endorsement';
import { Loadable } from '../../types';

export const NationalitiesContext = createContext<Loadable<NationalitiesDto[]>>({
  loading: false,
  result: null,
  error: null,
});
